module.exports = __webpack_public_path__ + "img/ph2supp2.42a1cf1f.png";